import React from "react";
import { motion } from "framer-motion";
import { Candy, Gift } from "lucide-react";
const XMAS_LOGO_URL = "/logo-christmas.jpg";

const FLOATERS = [
  { e: "🎄", x: "8%", y: "12%", d: 0, s: 34 },
  { e: "⭐", x: "84%", y: "18%", d: 0.6, s: 28 },
  { e: "🎁", x: "78%", y: "70%", d: 0.3, s: 40 },
  { e: "🍬", x: "5%", y: "74%", d: 0.9, s: 32 },
  { e: "❄️", x: "20%", y: "34%", d: 0.4, s: 26 },
  { e: "🍭", x: "90%", y: "44%", d: 1.1, s: 28 },
  { e: "🔔", x: "60%", y: "8%", d: 0.7, s: 30 },
  { e: "❄️", x: "70%", y: "88%", d: 0.2, s: 24 },
];

export const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 z-0">
        {FLOATERS.map((f, i) => (
          <motion.span
            key={i}
            className="absolute select-none drop-shadow-[0_0_10px_rgba(0,0,0,0.6)]"
            style={{ left: f.x, top: f.y, fontSize: f.s }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: [0, 1, 1], y: [20, -14, 20], rotate: [0, 8, -6, 0] }}
            transition={{ duration: 6 + f.d * 2, delay: f.d, repeat: Infinity, ease: "easeInOut" }}
            aria-hidden
          >
            {f.e}
          </motion.span>
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-14 sm:py-20 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="inline-flex items-center gap-2 bg-candy-teal text-white border-4 border-black rounded-full px-4 py-1.5 font-mono text-xs font-bold uppercase tracking-widest shadow-glow-purple mb-6">
            <Gift className="h-4 w-4" /> Calling All Bandits · Holiday Season
          </div>
          <h1 className="font-display text-6xl sm:text-7xl lg:text-8xl leading-[0.85] tracking-tight text-candy-cream">
            THE SWEET
            <br />
            <span className="text-candy-pink drop-shadow-[4px_4px_0_#000]">TOOTH</span>{" "}
            <span className="text-candy-teal drop-shadow-[4px_4px_0_#000]">BANDIT</span>
          </h1>
          <p className="mt-3 font-spooky text-3xl sm:text-4xl text-candy-gold drop-shadow-[2px_2px_0_#000]" data-testid="hero-tagline">
            The Christmas Candy Shop
          </p>
          <p className="mt-5 font-body text-base sm:text-lg max-w-md text-candy-cream/85 font-medium">
            Fall &amp; Christmas Candy Bouquets packed with sweets and stocking stuffers, made to
            order for everyone on your list. Steal a little holiday sweetness.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href="#shop-christmas"
              data-testid="hero-shop-btn"
              className="bg-candy-pink text-white font-bold uppercase tracking-wider py-3.5 px-7 border-4 border-black rounded-xl shadow-glow-orange hover:-translate-y-1 active:translate-x-1.5 active:translate-y-1.5 transition-transform duration-150 flex items-center gap-2"
            >
              <Candy className="h-5 w-5" /> See the Bouquets
            </a>
            <a
              href="#shop-merch"
              data-testid="hero-merch-btn"
              className="bg-candy-card text-candy-cream font-bold uppercase tracking-wider py-3.5 px-7 border-4 border-candy-teal rounded-xl hover:-translate-y-1 hover:shadow-glow-purple active:translate-x-1 active:translate-y-1 transition-all duration-150"
            >
              Shop Merch
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="relative flex justify-center"
        >
          <div className="absolute inset-0 holo-bg rounded-[2.5rem] rotate-6 border-4 border-black opacity-70 blur-[1px]" />
          <div className="absolute -inset-6 rounded-full bg-candy-pink/20 blur-3xl" />
          <motion.img
            src={XMAS_LOGO_URL}
            alt="Sweet Tooth Bandit mascot badge"
            className="relative z-10 w-72 sm:w-96 rounded-full animate-float drop-shadow-[0_0_40px_rgba(255,215,0,0.45)]"
          />
        </motion.div>
      </div>
    </section>
  );
};
